var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Controller } from "react-hook-form";
import useUniqueId from "../../Hooks/useUniqueId";
import ValidationService from "../../../Services/Shared/Validation.service";
import { debouncePromise } from "../../../../util/debounce";
import OutreachService from "../../../Services/Outreach.service";
import Checkbox from "../../UI/Form/Checkbox";
import { AlertTypes } from "../../../Domain/AlertType.model";
import AlertService from "../../../Services/Alert.service";
import AcademicPlanService from "../../../Services/AcademicPlan.service";
import useService from "../../Hooks/useService";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
import useHasPermission from "../../Hooks/useHasPermission";
import useAcademicPlanConfiguration from "../../Hooks/useAcademicPlanConfiguration";
const OFF_PLAN_STATUS_ID = 3;
const CloseAlertForm = (_a) => {
    var _b, _c;
    var { personAlertState, personAlertId } = _a, formProps = __rest(_a, ["personAlertState", "personAlertId"]);
    const makeId = useUniqueId()[1];
    const [_personAlertState, loadPersonAlert] = useService(AlertService.getPersonAlert);
    const [_academicPlanTermStatus, loadAcademicPlanTermStatus] = useService(AcademicPlanService.getAcademicPlanTermStatusForOffPlanAlertCreatedDate);
    const safePersonAlertState = personAlertState || _personAlertState;
    let showMarkAcademicPlanTermOnPlanCheckbox = false;
    const canSeeAcademicPlans = useHasPermission("CAN_SEE_ACADEMIC_PLANS");
    const academicPlanConfiguration = useAcademicPlanConfiguration();
    // load the academic plan calendars associated with the specified alert
    React.useEffect(() => {
        if (!personAlertState) {
            loadPersonAlert(personAlertId);
        }
    }, [loadPersonAlert, personAlertId, personAlertState]);
    if ((safePersonAlertState === null || safePersonAlertState === void 0 ? void 0 : safePersonAlertState.wasSuccessful) &&
        ((_b = safePersonAlertState === null || safePersonAlertState === void 0 ? void 0 : safePersonAlertState.data) === null || _b === void 0 ? void 0 : _b.alertTypeId) === AlertTypes.OFF_PLAN_ID &&
        !_academicPlanTermStatus.isLoading &&
        !_academicPlanTermStatus.wasSuccessful &&
        !_academicPlanTermStatus.hasError) {
        loadAcademicPlanTermStatus(
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        safePersonAlertState.data.person.affiliationId, 
        // @ts-expect-error - TS2345 - Argument of type 'Date | null | undefined' is not assignable to parameter of type 'Date'.
        safePersonAlertState.data.createdDateAsDate);
    }
    if ((_academicPlanTermStatus === null || _academicPlanTermStatus === void 0 ? void 0 : _academicPlanTermStatus.wasSuccessful) &&
        (academicPlanConfiguration === null || academicPlanConfiguration === void 0 ? void 0 : academicPlanConfiguration.wasSuccessful) &&
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        _academicPlanTermStatus.data.id === OFF_PLAN_STATUS_ID) {
        // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean'.
        showMarkAcademicPlanTermOnPlanCheckbox =
            ((_c = academicPlanConfiguration === null || academicPlanConfiguration === void 0 ? void 0 : academicPlanConfiguration.data) === null || _c === void 0 ? void 0 : _c.enableAcademicPlanning) &&
                canSeeAcademicPlans;
    }
    // if (
    //   safePersonAlertState?.wasSuccessful &&
    //   academicPlanConfiguration?.wasSuccessful &&
    //   _academicPlanTermStatus?.wasSuccessful
    // ) {
    //   showMarkAcademicPlanTermOnPlanCheckbox =
    //     safePersonAlertState.data.alertTypeId === AlertTypes.OFF_PLAN_ID &&
    //     canSeeAcademicPlans &&
    //     academicPlanConfiguration.data.enableAcademicPlanning;
    // }
    return (_jsx(ServiceResult, { state: safePersonAlertState, children: (personAlert) => {
            var _a, _b;
            return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("outreach"), children: "Outreach" }), _jsx(Controller, { name: "outreach", control: formProps.control, as: _jsx(DeprecatedSelect.Async, { "aria-label": "Outreach", labelKey: "name", valueKey: "id", className: ValidationService.makeClassName(formProps.errors, "outreach"), id: makeId("outreach"), loadOptions: debouncePromise((search) => OutreachService.search({ query: search }).then((options) => ({
                                        options,
                                    })), 200) }) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("comment"), children: "Comment" }), _jsx("textarea", { id: makeId("comment"), className: ValidationService.makeClassName(formProps.errors, "comment", "form-control"), name: "comment", ref: formProps.register({
                                    // @ts-expect-error - TS7006 - Parameter 'val' implicitly has an 'any' type.
                                    validate: (val) => formProps.getValues().sendCommentInEmailToCreator &&
                                        !(val === null || val === void 0 ? void 0 : val.length)
                                        ? "Comment is required if sending in email to alert creator"
                                        : true,
                                }) }), _jsx("div", { className: "invalid-feedback", children: (_a = formProps.errors.comment) === null || _a === void 0 ? void 0 : _a.message })] }), personAlert.isStaffInitiated && (_jsx("div", { className: "form-group", children: _jsx(Checkbox, { id: makeId("sendCommentInEmailToCreator"), ref: formProps.register, name: "sendCommentInEmailToCreator", label: `Include this comment in the email that will be sent to ${(_b = personAlert.createdByPerson) === null || _b === void 0 ? void 0 : _b.fullName}, who created this alert.` }) })), showMarkAcademicPlanTermOnPlanCheckbox && (_jsx(_Fragment, { children: _jsx(Checkbox, { id: makeId("markAcademicPlanTermOnPlan"), ref: formProps.register, name: "markAcademicPlanTermOnPlan", label: "Change the status of the term in the student's Academic Plan to On Plan" }) }))] }));
        } }));
};
export default CloseAlertForm;
